var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
var HasuraStorageApi = /** @class */ (function () {
    function HasuraStorageApi(_a) {
        var url = _a.url;
        this.url = url;
        this.httpClient = axios.create({
            baseURL: this.url,
            timeout: 10000,
        });
    }
    HasuraStorageApi.prototype.upload = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.httpClient.post('/files', params.file, {
                                headers: __assign(__assign({}, this.generateUploadHeaders(params)), this.generateAuthHeaders()),
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, { fileMetadata: res.data, error: null }];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, { fileMetadata: null, error: error_1 }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HasuraStorageApi.prototype.getPresignedUrl = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var fileId, res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        fileId = params.fileId;
                        return [4 /*yield*/, this.httpClient.get("/files/" + fileId + "/presignedurl", {
                                headers: __assign({}, this.generateAuthHeaders()),
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, { presignedUrl: res.data, error: null }];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, { presignedUrl: null, error: error_2 }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HasuraStorageApi.prototype.delete = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var fileId, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        fileId = params.fileId;
                        return [4 /*yield*/, this.httpClient.delete("/files/" + fileId, {
                                headers: __assign({}, this.generateAuthHeaders()),
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, { error: null }];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/, { error: error_3 }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HasuraStorageApi.prototype.setAccessToken = function (accessToken) {
        this.accessToken = accessToken;
    };
    HasuraStorageApi.prototype.generateUploadHeaders = function (params) {
        var bucketId = params.bucketId, name = params.name, id = params.id;
        var uploadheaders = {};
        if (bucketId) {
            uploadheaders['x-nhost-bucket-id'] = bucketId;
        }
        if (id) {
            uploadheaders['x-nhost-file-id'] = id;
        }
        if (name) {
            uploadheaders['x-nhost-file-name'] = name;
        }
        return uploadheaders;
    };
    HasuraStorageApi.prototype.generateAuthHeaders = function () {
        if (!this.accessToken) {
            return null;
        }
        return {
            Authorization: "Bearer " + this.accessToken,
        };
    };
    return HasuraStorageApi;
}());
export { HasuraStorageApi };
//# sourceMappingURL=hasura-storage-api.js.map